// import React, { useRef, useEffect, useState } from "react";
// import ActionBar from "./ActionBar";
// import KpiCards from "./KpiCards";
// import useDynamicForm from "./useDynamicForm";
// import UserForm from "./UserForm";
// import UserTable from "./UserTable";

// /**
//  * UserMgmtLanding Component
//  * Entry point for managing users: KPIs, Actions, Form, Table
//  */
// const UserMgmtLanding: React.FC = () => {
//   const [showForm, setShowForm] = useState(false);
//   const formHook = useDynamicForm();
//   const formRef = useRef<HTMLDivElement>(null);

// const handleAddUser = () => {
//     setShowForm(true);
//     formHook.clearAllForms();
// };

//   const handleEditUser = (user: any) => {
//     setShowForm(true);
//     formHook.loadUserForEdit(user);
//   };

//   const handleFormClose = () => {
//     setShowForm(false);
//     formHook.clearAllForms();
//   };

//   //Commented the code for clicking outside modal closes

//  /*
//   useEffect(() => {

//     const handleClickOutside = (event: MouseEvent) => {
//       if (
//         showForm &&
//         formRef.current &&
//         !formRef.current.contains(event.target as Node)
//       ) {
//         handleFormClose();
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [showForm]);
//   */

//   return (
//     <div className="min-h-screen relative">
//       <div className="mx-auto">
//         {/* Page Heading */}
//         <div className="mb-4">
//           <h1 className="page-title">
//             User Management
//           </h1>
//           <p className="page-subtitle">
//             Manage user accounts and permissions across your organization.
//           </p>
//         </div>

//         {/* KPI Summary Cards */}
//         <KpiCards />

//         {/* Action Bar: Add User */}  
//         <ActionBar onAddUser={handleAddUser} />

//         {/* Inline Form Section with outside-click detection */}
//         {showForm && (
//           <div ref={formRef} className="mb-8">
//             <UserForm formHook={formHook} onClose={handleFormClose} />

//           </div>
//         )}

//         {/* User Listing Table */}
//         <UserTable onEditUser={handleEditUser} />
//       </div>
//     </div>
//   );
// };

// export default UserMgmtLanding;

import React, { useRef, useState } from "react";
import ActionBar from "./ActionBar";
import KpiCards from "./KpiCards";
import UserForm from "./UserForm";
import UserTable from "./UserTable";
import { UserItem } from "@features/onboarding/utility-setup/types";

/**
 * UserMgmtLanding Component
 * Entry point for managing users: KPIs, Actions, Form, Table
 */
const UserMgmtLanding: React.FC = () => {
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState<UserItem | null>(null);
  const formRef = useRef<HTMLDivElement>(null);

  const handleAddUser = () => {
    setEditingUser(null);
    setShowForm(true);
  };

  const handleEditUser = (user: UserItem) => {
    setEditingUser(user);
    setShowForm(true);
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingUser(null);
  };

  return (
    <div className="min-h-screen relative">
      <div className="mx-auto">
        {/* Page Heading */}
        <div className="mb-4">
          <h1 className="page-title">User Management</h1>
          <p className="page-subtitle">
            Manage user accounts and permissions across your organization.
          </p>
        </div>

        {/* KPI Summary Cards */}
        <KpiCards />

        {/* Action Bar: Add User */}
        <ActionBar onAddUser={handleAddUser} />

        {/* Inline Form Section */}
        {showForm && (
          <div ref={formRef} className="mb-8">
            <UserForm 
              onClose={handleFormClose} 
              editingUser={editingUser}
            />
          </div>
        )}

        {/* User Listing Table */}
        <UserTable onEditUser={handleEditUser} />
      </div>
    </div>
  );
};

export default UserMgmtLanding;